import Button from "shared/components/Button";

const ActionButtons = ({
  onBack,
  onSubmit,
  loading,
  disabled = { next: false, previous: false },
  icons = { next: null, previous: null },
  translation,
}) => (
  <div className="ac-collectif__actions">
    {onBack && (
      <Button
        onClick={onBack}
        type="secondary--link"
        disabled={disabled.previous}
      >
        {icons.previous}
        {translation.PREVIOUS}
      </Button>
    )}
    <Button
      type="primary"
      onClick={onSubmit}
      loading={loading}
      disabled={disabled.next}
    >
      {translation.NEXT}
      {icons.next}
    </Button>
  </div>
);

export default ActionButtons;
